import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
require('./BoxOptions.scss');

class BoxOptions extends PureComponent {
    constructor(props) {
        super(props);

        const { defaultSelected, selectedBox } = props;
        this.state = {
            controlled: !!selectedBox,
            selectedBox: [defaultSelected],
        };
    }

    checkMultipleSelection = currentSelectedBox => {
        const { selectedBox } = this.state;
        if (selectedBox.includes(currentSelectedBox)) {
            this.setState(prevstate => ({
                selectedBox: [...prevstate.selectedBox.filter(option => option !== currentSelectedBox)],
            }));
        } else {
            this.setState(prevstate => ({ selectedBox: [...prevstate.selectedBox, currentSelectedBox] }));
        }
    };

    handleClickBox = currentSelectedBox => {
        const { multipleSelection } = this.props;
        if (multipleSelection) {
            this.checkMultipleSelection(currentSelectedBox);
        } else {
            this.setState({ selectedBox: [currentSelectedBox] });
        }
    };

    onClick = (childHandleSelected, selectedBox, event) => {
        const { controlled } = this.state;
        childHandleSelected && childHandleSelected(selectedBox, event);
        !controlled && this.handleClickBox(selectedBox);
    };

    getSelectedBox = () => {
        const { controlled, selectedBox: stateSelectedBox } = this.state;
        const { selectedBox } = this.props;
        return controlled ? selectedBox : stateSelectedBox;
    };

    getChildren = () => {
        const { children } = this.props;
        const selectedBox = this.getSelectedBox();
        return React.Children.map(children, (child, i) => {
            return React.cloneElement(child, {
                onClick: event => this.onClick(child.props.onClick, i, event),
                selected: selectedBox.includes(i),
            });
        });
    };

    render() {
        return <div className="open-box-options">{this.getChildren()}</div>;
    }
}

BoxOptions.propTypes = {
    children: PropTypes.node.isRequired,
    multipleSelection: PropTypes.bool,
    defaultSelected: PropTypes.number,
    selectedBox: PropTypes.array,
};

BoxOptions.defaultProps = {
    children: '',
    multipleSelection: false,
    defaultSelected: 0,
};

export default BoxOptions;
